import { t } from "i18next";
import React, { useEffect, useState } from "react";
import CurrencyConverter from "../../Currency/CurrencyConverter";

const SubscriptionPlanSelector = ({
  subscriptionPlans,
  currency,
  conversionFactor,
  planError,
  setPlanError,
  setSubscriptionPlan,
}) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  
  const handlePlanSelect = (plan) => {
    setSelectedPlan(plan.subscription);
    setPlanError("");
    if (setSubscriptionPlan) {
      setSubscriptionPlan(plan.subscription);
    }
  };
  
  useEffect(() => {
    let timeout;
  
    if (planError) {
      timeout = setTimeout(() => {
        setPlanError("");
      }, 2000);
    }
  
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [planError]);
  

  return (
    <div style={{ margin: "1rem 0", padding: "1rem" }}>
      <div
        style={{
          fontFamily: "system-ui, -apple-system, sans-serif",
          margin: "0 auto",
          padding: "30px 15px",
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
        }}
      >
        <h3
          style={{
            fontSize: "16px",
            margin: "0 0 12px 0",
            marginBottom:'1.5rem',
            marginLeft:'.1rem',
            color: "#444",
          }}
        >
          Choose a Subscription Plan
        </h3>
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
          }}
        >
          {subscriptionPlans.map((plan, i) => (
            <div
              key={i}
              onClick={() => handlePlanSelect(plan)}
              style={{
                flex: "1",
                padding: "12px",
                backgroundColor:
                  selectedPlan === plan.subscription ? "#edf5ff" : "#fff",
                border:
                  selectedPlan === plan.subscription
                    ? "2px solid #2c7be5"
                    : "2px solid #e0e0e0",
                borderRadius: "6px",
                textAlign: "center",
                cursor: "pointer",
                transition: "all 0.2s ease",
                position: "relative",
              }}
            >
              {selectedPlan === plan.subscription && (
                <div
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    width: "16px",
                    height: "16px",
                    borderRadius: "50%",
                    backgroundColor: "#2c7be5",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "10px",
                    fontWeight: "bold",
                  }}
                >
                  ✓
                </div>
              )}
              <div style={{ fontWeight: "600", marginBottom: "5px" }}>
                {plan.subscription} year
              </div>
              <div
                style={{
                  color:
                    selectedPlan === plan.subscription ? "#2c7be5" : "#555",
                  fontWeight: "700",
                }}
              >
                {currency?.symbolLeft || "$"} {""}
                {CurrencyConverter(plan.amount, conversionFactor)}
              </div>
            </div>
          ))}
        </div>
      </div>
      {planError && (
         <span style={{marginTop:'1rem'}} className="validation-error-message">
         {planError}
       </span>
      )}
    </div>
  );
};

export default SubscriptionPlanSelector;
